import React from 'react';
import { MainTitle } from '.';
import routeConstant from '../../constants/route.constants';
import FullPageLink from './FullPageLink';

const ContactModal = () => (
  <div className="modal-content-wrapper">
    <MainTitle>Liên hệ</MainTitle>
    <FullPageLink url={routeConstant.CONTACT} />

    <div className="main-content">
      <div id="main_0_DivCode">
        <h4>Liên hệ Mr Emil (email : admin@emil.vn) nếu bạn:</h4>
        <ul>
          <li style={{ paddingLeft: '10px' }}>
            Có câu hỏi hoặc phản hồi về các chính sách và quy trình của chúng tôi.
          </li>
          <p></p>
          <li style={{ paddingLeft: '10px' }}>Cần hướng dẫn hoặc trợ giúp khi sử dụng ứng dụng.</li>
        </ul>
      </div>
    </div>
  </div>
);

export default ContactModal;
